import request from '../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../types/enums/request-enums';
import { CreateStudioPromptRequest, UpdateStudioPromptRequest } from '../../types/StudioPrompt';

const CreateStudioPrompt = (data: CreateStudioPromptRequest): Promise<any> =>
    request({
        url: ApiURL.Command.StudioCommandURLs.StudioPromptCommandURL.PostStudioPrompt,
        method: RequestType.POST,
        data,
    });

const UpdateStudioPrompt = (id: number, data: UpdateStudioPromptRequest): Promise<any> =>
    request({
        url: `${ApiURL.Command.StudioCommandURLs.StudioPromptCommandURL.PutStudioPrompt}/${id}`,
        method: RequestType.PUT,
        data,
    });

const DeleteStudioPrompt = (id: number): Promise<any> =>
    request({
        url: `${ApiURL.Command.StudioCommandURLs.StudioPromptCommandURL.DeleteStudioPrompt}/${id}`,
        method: RequestType.DELETE,
    });

export const StudioPromptCommand = {
    CreateStudioPrompt,
    UpdateStudioPrompt,
    DeleteStudioPrompt,
};

export default StudioPromptCommand;

